import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';

import './index.sass';
import { datetimeFromUTC } from 'utils/dayjs';

const { block, el } = bem('timepicker');
const TimePicker = ({ time, setTime, times, selected }) => {
    const onChange = (time) => (e) => {
        if (alreadySelected(time)) {
            return;
        }
        setTime(time);
    }

    const alreadySelected = (time) => {
        return selected.includes(time);
    }

    return (
        <div className={ block() }>
            <div className={ el('title') }>
                <Text>{ 'Свободное время\nдля записи:' }</Text>
            </div>
            <div className={ el('spacer') }/>
            <div className={ el('times') }>
                {
                    times.sort().map((t, index) =>
                        <div
                            key={ index }
                            className={ el('time', { 'active': time === t }, { 'already-selected': alreadySelected(t)}) }
                            onClick={ onChange(t) }>
                            <Text>{ datetimeFromUTC(t)?.time }</Text>
                        </div>
                    )
                }
            </div>
        </div>
    )
}

export default TimePicker;
